export type AcquisitionType = 'CONTACT_SALES' | 'STRIPE_CHECKOUT' | 'INCLUDED';

export type RunnerMode = 'cloud' | 'local';

export const GATE = {
  CAM: 'cam',
} as const;

export interface EntitlementResponse {
  skillId: string;
  displayName: string;
  description: string;
  category: string;
  acquisitionType: AcquisitionType;
  enabled: boolean;
  status: string | null;
  expiresAt: string | null;
  supportedRunners: RunnerMode[];
  infoText: string | null;
  skillKeys: string[];
}

export interface EntitlementsListResponse {
  skills: EntitlementResponse[];
  openGates: string[];
}
